module.exports = __webpack_public_path__ + "img/leumicard-max-stacked.4cf23e11.png";